// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eVHoB","block":"Footer_block__D8dMQ","info":"Footer_info__arQ9R"};